import { useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import _includes from 'lodash/includes';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import { eventGalleryQuery } from '../../apollo/events';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { useQuery } from '@apollo/client';
import UploadImagesBox from '../../components/upload-images-box';
import ImageUploadGallery from '../image-upload-gallery';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(2, 0),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerButtons: {
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  loadMorebutton: {
    marginTop: theme.spacing(1),
  },
}));

const EventImageUploads = ({ event, ...rest }) => {
  const classes = useStyles();

  const [uploadOpen, setUploadOpen] = useState(false);
  const [galleryLoaded, setGalleryLoaded] = useState(event.imageUploads && event.imageUploads.length === event.imageUploadsCount);
  
  const handleToggleUploadOpen = useCallback(() => {
    setUploadOpen(!uploadOpen);
  }, [uploadOpen]);
  
  const {
    data: galleryData,
    loading: galleryDataLoading,
  } = useQuery(eventGalleryQuery, {
    variables: {
      id: event.id,
    },
    skip: !galleryLoaded,
  });

  const handleLoadGallery = useCallback(() => {
    setGalleryLoaded(true);
  }, []);
  
  const { membership, imageUploadsCount } = event;
  const imageUploads = useMemo(() => (
    galleryData ? _get(galleryData, 'event.imageUploads') : event.imageUploads
  ), [event, galleryData]);

  return (
    <div className={classes.wrapper} {...rest}>
      <Typography variant="h2" className={classes.header}>
        <div className={classes.header}>
          Photos
        </div>
        <div className={classes.headerButtons}>
          {membership && _includes(['GOING', 'INTERESTED', 'NOT_GOING'], membership.status) && (
            <Button
              onClick={handleToggleUploadOpen}
              variant="contained"
              color="primary"
              size="small"
            >
              Upload Photos
            </Button>
          )}
        </div>
      </Typography>

      {uploadOpen && (
        <UploadImagesBox
          event={event}
          onClose={handleToggleUploadOpen}
        />
      )}

      <ImageUploadGallery
        imageUploads={imageUploads}
        galleryId={event.id}
      />

      {!galleryLoaded && (
        <Button
          onClick={handleLoadGallery}
          variant="outlined"
          className={classes.loadMorebutton}
        >
          {galleryDataLoading ? 'Loading...' : `Load Full Gallery (${imageUploadsCount})`}
        </Button>
      )}
    </div>
  );
};

EventImageUploads.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventImageUploads;
